export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_2.2e691052.mp3";